import { PayloadAction } from '@reduxjs/toolkit';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const LOCAL__ui_drag_and_drop_set_hovered_graph_field = (payload: FIELD__base = FIELD__base.CREATE_STUB()): PayloadAction<FIELD__base> => ({
  type: ENUM__redux_action.UI_DRAG_AND_DROP_SET_HOVERED_GRAPH_FIELD,
  payload,
});

export function INIT_LOCAL__ui_drag_and_drop_set_hovered_graph_field(state: STATE__ui, action: PayloadAction<FIELD__base>) {
  let field_new = action.payload;
  let field_old = state.drag_and_drop__image_external_zone_hovered_graph_field;

  if (field_old.is_stub() && field_new.is_stub()) return; //nothing to change
  if (field_new.meta.field_id == field_old.meta.field_id && field_new.meta.graph_id == field_old.meta.graph_id) return; //nothing to change

  state.drag_and_drop__image_external_zone_hovered_graph_field = field_new.clone();
}
